export default __webpack_public_path__ + "static/media/therapies.c0ff551b.png";